import { ClipboardList, Home, LibraryBig, Plus, User } from "lucide-react";
import { cn } from "@/lib/utils";

export type GrowthTab = "home" | "practice" | "records" | "mine";

type BottomNavProps = {
	active: GrowthTab;
	onNote: () => void;
	onTab: (tab: GrowthTab) => void;
};

const tabs = [
	{ id: "home", label: "首页", Icon: Home },
	{ id: "practice", label: "练习", Icon: LibraryBig },
	{ id: "records", label: "记录", Icon: ClipboardList },
	{ id: "mine", label: "我的", Icon: User },
] as const;

/** Stateless navigation shared by the live growth flow and the isolated UI preview. */
export function BottomNav({ active, onNote, onTab }: BottomNavProps) {
	return (
		<nav aria-label="主导航" className="bottom-nav">
			<div className="bottom-nav-row">
				{tabs.map(({ Icon, id, label }, index) => (
					<button
						aria-label={label}
						aria-current={active === id ? "page" : undefined}
						className={cn("bottom-tab", active === id && "active", index === 1 && "nav-gap")}
						key={id}
						onClick={() => onTab(id)}
						type="button"
					>
						<span className="bottom-tab-dot" />
						<Icon size={23} strokeWidth={active === id ? 2.6 : 2.2} />
						<span className="bottom-tab-label">{label}</span>
					</button>
				))}
			</div>
			<button aria-label="随心记" className="note-fab" onClick={onNote} type="button">
				<Plus size={24} strokeWidth={2.6} />
			</button>
		</nav>
	);
}
